module.exports = __webpack_public_path__ + "static/media/27OCHA1.99343f3b.jpg";